import { useRecoilValue } from 'recoil';
import { authState } from 'states';
import { isSuperAdminRoleCode } from 'helpers/roles';

/**
 * Whether the signed-in user may see raw JSON. There is no ADVANCED_CONFIG action in the backend yet,
 * so for now this is the existing super-admin flag.
 */
export const useAdvancedAccess = (): boolean => {
  const auth = useRecoilValue(authState);
  return isSuperAdminRoleCode(auth?.roles?.[0]);
};
